import * as Yup from "yup";
import { useFormik } from "formik";
import React from "react";

import { FormControlLabel, FormHelperText, Radio, RadioGroup } from "@mui/material";

import { QuestionaireBasePage } from "./QuestionaireBasePage";
import { OptionDefinitionDto, Question, QuestionDefinitionDto } from "./questionaire-types";

type SingleOptionPageProps = {
  questionDefinition: QuestionDefinitionDto;
  onNext: (question: Question) => void;
  getIcon?: (option: OptionDefinitionDto) => any;
  getCheckedIcon?: (option: OptionDefinitionDto) => any;
  isSaving: boolean;
  isFrenchLanguage:boolean;
};

export const SingleOptionPage = (props: SingleOptionPageProps) => {
  const { questionDefinition, onNext, getIcon = () => undefined, getCheckedIcon = () => undefined, isSaving } = props;
  const formik = useFormik({
    initialValues: {
      answer: "",
    },
    validationSchema: Yup.object().shape({
      answer: !props.isFrenchLanguage?
      Yup.string().required("Please select an option"):
      Yup.string().required("Veuillez sélectionner une option"),
      
    }),
    onSubmit: (value) => {
      const answerKey = value.answer;
      const selectedAnswer = questionDefinition.options?.find((o) => o.key === answerKey)!;
      const question = {
        key: questionDefinition.key,
        label: questionDefinition.title,
        answers: [
          {
            key: selectedAnswer.key,
            label: selectedAnswer.label,
          },
        ],
      };
      onNext(question);
    },
  });

  return (
    <QuestionaireBasePage questionDefinition={questionDefinition} formik={formik} isSaving={isSaving} isFrenchLanguage={props.isFrenchLanguage}>
      <RadioGroup value={formik.values.answer} onChange={formik.handleChange}>
        {questionDefinition.options?.map((o) => (
          <FormControlLabel key={o.key} control={<Radio name="answer" value={o.key} icon={getIcon(o)} checkedIcon={getCheckedIcon(o)} />} label={o.label} />
        ))}
      </RadioGroup>
      <FormHelperText error={formik.touched.answer && Boolean(formik.errors.answer)}>{formik.touched.answer ? formik.errors.answer : ""}</FormHelperText>
    </QuestionaireBasePage>
  );
};
